module.exports = __webpack_public_path__ + "static/collect-3-bb1b2fb51d2dfb3216e5182f3699c953.png";